import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import SportsClubs from "@/pages/SportsClubs";
import Schools from "@/pages/Schools";
import Farms from "@/pages/Farms";
import TrusteeHub from "@/pages/TrusteeHub";
import CaseStudy from "@/pages/CaseStudy";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/sectors/sports-clubs" element={<SportsClubs />} />
            <Route path="/sectors/schools" element={<Schools />} />
            <Route path="/sectors/farms" element={<Farms />} />
            <Route path="/trustee-hub" element={<TrusteeHub />} />
            <Route path="/case-study" element={<CaseStudy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
